import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Avatar } from 'primeng/avatar';
import { AuthService } from '../services/login.service';
import { ProfileService } from '../api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-template',
  imports: [RouterOutlet, Avatar],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss',
})
export class TemplateComponent implements OnInit {
  authService = inject(AuthService);
  profileService = inject(ProfileService);
  translate = inject(TranslateService);
  links = signal<{ url: string; label: string }[]>([
    { url: 'https://www.jtbank.cz/', label: 'JTBank.cz' },
    { url: 'https://www.jtbank.cz/', label: 'Návod' },
    {
      url: 'https://www.jtbank.cz/kontakty',
      label: 'Kontakty',
    },
  ]);
  userNameShorthand = signal<string>('');
  userName = signal<string>('');

  ngOnInit() {
    this.profileService
      .getProfileInformation(self.crypto.randomUUID())
      .subscribe(profile => {
        if (profile.user?.first_name && profile.user?.last_name) {
          this.userNameShorthand.set(
            `${profile.user?.first_name[0]}${profile.user?.last_name[0]}`
          );
        }

        this.userName.set(
          profile.user?.username || this.translate.instant('common.user')
        );
      });
  }
  logout() {
    this.authService.logout();
  }

  public scrollToTop() {
    window.scrollTo({ behavior: 'smooth', top: 0, left: 0 });
  }
}
